import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box} from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';


export default function StockorderproductInfo({stockorderproductObj}){
    return (
      <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: { xs: window.screen.height - 250, lg: window.screen.height } }}>
        
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{backgroundColor:'secondary.100', }}
      >
            
        <Grid item lg={2} xs={5}><FieldView2 label="Product Name"  value={ stockorderproductObj.productname!==null && stockorderproductObj.productname!==undefined?stockorderproductObj.productname:'NOT KNONWN' }/></Grid>
        <Grid item lg={2} xs={5}><FieldView2 label="Matter"  value={ stockorderproductObj.matter?stockorderproductObj.matter:'-' }/></Grid>
        <Grid item lg={2} xs={2}><FieldView2 label="Qty"  value={ stockorderproductObj.qty!==null && stockorderproductObj.qty!==undefined?stockorderproductObj.qty:'NOT KNONWN' }/></Grid>
        <Grid item lg={2} xs={4}><FieldView2 label="Stitching Type"  value={ stockorderproductObj.stitchingtype?'Simple':'Technical' }/></Grid>
        
        <Grid item lg={2} xs={4}><FieldView2 label="With Printing"  value={ stockorderproductObj.withprinting?'Yes':'No' }/></Grid>
        
        {stockorderproductObj.withprinting?
          <Grid item lg={2} xs={4}><FieldView2 label="Printing Type"  value={ stockorderproductObj.printingtype?'Digital':'Screen' }/></Grid>
          :<Grid item lg={2} xs={4}><FieldView2 label="Printing Type"  value='NA'/></Grid>
        }
        
        <Grid item lg={2} xs={4}><FieldView2 label="Priority"  value={stockorderproductObj.priorityid===1?'URGENT': 'Standard'}/></Grid>
        <Grid item lg={2} xs={4}><FieldView2 label="Expected By" value={ stockorderproductObj.expecteddelivery?stockorderproductObj.expecteddelivery.split('T')[0]:'-' }/></Grid>
        
        <Grid item lg={2} xs={4}><FieldView2 label="Received Qty"  value={ stockorderproductObj.receivedqty!==null && stockorderproductObj.receivedqty!==undefined?stockorderproductObj.receivedqty:'NOT KNONWN' }/></Grid>
        <Grid item lg={6} xs={12}><FieldView2 label="Remarks"  value={ stockorderproductObj.remarks!==null && stockorderproductObj.remarks!==undefined?stockorderproductObj.remarks:'-' }/></Grid>
      </Grid>
      </Grid>
      </Box>
    )
}